import { colors } from "../../../styles/figmaColors";
import { useTranslation } from "react-i18next";
import { Tag } from "../Tag/Tag";
import "../../../../i18n/i18n";

type LinkyConsentStatus = "VALIDATED" | "PENDING" | "NOT_SENT";

const statusProps: Record<
  LinkyConsentStatus,
  { backgroundColor: string; textColor: string }
> = {
  VALIDATED: {
    backgroundColor: colors["colors/system/success/success_ultraLight"],
    textColor: colors["colors/system/success/success_normal"],
  },
  PENDING: {
    backgroundColor: colors["colors/system/informative/informative_ultraLight"],
    textColor: colors["colors/system/informative/informative_normal"],
  },
  NOT_SENT: {
    backgroundColor: colors["colors/surfaces/background/background_level2"],
    textColor: colors["colors/text/darkGrey"],
  },
};

interface TableTagLinkyConsentStatusProps {
  status: string;
}

export const TableTagLinkyConsentStatus = (
  props: TableTagLinkyConsentStatusProps,
) => {
  const { t } = useTranslation();
  const statusProp = statusProps[props.status as LinkyConsentStatus];
  if (!statusProp) {
    return null;
  }

  return (
    <Tag
      text={t(`linky_consents.status.${props.status}`)}
      backgroundColor={statusProp.backgroundColor}
      textColor={statusProp.textColor}
    />
  );
};
